import React, { Fragment } from 'react'
import { Form, Checkbox } from 'antd'
import { Controller } from 'react-hook-form'

type OptionType = {
  label?: string
  value?: string
}
export interface CheckBoxGroupProps {
  fieldname: string
  isRequired?: boolean
  label?: string
  validate?: any
  validMessage?: any
  className?: string
  control: any
  initValue?: any
  rules?: any
  iProps?: any
  onChangeCheck?: any
  optionsData?: Array<OptionType>
}

const CheckBoxGroup: React.FunctionComponent<CheckBoxGroupProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  optionsData,
  onChangeCheck,
}: CheckBoxGroupProps) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      validateStatus={validate}
      help={validMessage}
      label={label}
      valuePropName="checked"
      className={className}
    >
      <Controller
        rules={rules}
        name={fieldname}
        control={control}
        defaultValue={initValue ?? ''}
        render={({ field: { onChange, value } }) => (
          <Checkbox.Group
            value={value}
            {...iProps}
            onChange={(e) => {
              onChange(e)
              onChangeCheck(e)
            }}
          >
            {optionsData &&
              optionsData?.map((e: any) => (
                <Fragment key={e?.value}>
                  <Checkbox value={e?.value}>{e?.label}</Checkbox>
                </Fragment>
              ))}
          </Checkbox.Group>
        )}
      />
    </Form.Item>
  )
}

export default CheckBoxGroup
